import { IsiDtoPlGridManagerRequest, IsiDtoPlGridManagerResponse, IsiDtoPlGridManagerResult } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlGridManager";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiPresentationLogic } from "./IsiPresentationLogic";

export class IsiPlGridManager extends IsiPresentationLogic {

    constructor() {
        super("IsiPlGridManagerHandler");
    }

    public async getCount(contextId: string, clientCtrlValues: { [key: string]: string; }): Promise<IIsiUIFlowResultGeneric<IsiDtoPlGridManagerResult>> {
        const request = IsiDtoPlGridManagerRequest.fromJS({
            contextId: contextId,
            clientCtrlsValues: clientCtrlValues,
            response: IsiDtoPlGridManagerResponse.fromJS({
            })
        });

        this.abortActionIfExist(contextId, "GetCount");

        const result = await this.abortableAjaxActionWithErrorLoggin(contextId, "GetCount", request, false);

        return {
            continue: result.continue,
            result: result.result,
            reponse: result?.reponse?.response?.getCountResult
        }

    }
}
